import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProjectCard({ project, index = 0, className = "", aspect = "aspect-[4/3]" }) {
  return (
    <Link to={`/projects/${project.slug || project.id}`} data-testid={`project-card-${project.slug || project.id}`} className={`group block ${className}`}>
      <div className={`img-zoom relative bg-[#EFECE6] ${aspect} frame-clip`}>
        <img
          src={project.cover_image}
          alt={project.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <span className="absolute top-4 left-4 bg-[#F8F6F0]/90 backdrop-blur px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] text-[#181816]">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="absolute bottom-4 right-4 h-9 w-9 bg-[#F8F6F0]/90 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
      <div className="flex items-start justify-between pt-4 gap-4">
        <div>
          <h3 className="font-serif text-xl sm:text-2xl leading-snug group-hover:italic transition-all duration-300">{project.title}</h3>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-[#8A857D]">
            {project.location}{project.typology ? ` · ${project.typology}` : ""}{project.year ? ` · ${project.year}` : ""}
          </p>
        </div>
      </div>
    </Link>
  );
}
